import {
  ContentCopy,
  Delete,
  AccessTime,
} from "@mui/icons-material";
import React, { memo } from "react";
import { useNodeStorage } from "../../../stores/useNodeStorage";
import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable, id }) => {
  const storageItems = useNodeStorage();

  const getScheduleLabel = (type) => {
    const labels = {
      delay: "Após X minutos",
      specific_time: "Hora específica",
      recurring: "Recorrente",
    };
    return labels[type] || type;
  };

  return (
    <div style={{
      backgroundColor: "#ffffff",
      padding: "16px",
      borderRadius: "12px",
      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      border: '1px solid #e5e7eb',
      minWidth: '280px',
      maxWidth: '320px',
      position: 'relative'
    }}>
      <Handle
        type="target"
        position="left"
        style={{
          background: "#ec4899",
          width: "12px",
          height: "12px",
          top: "50%",
          left: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        onConnect={(params) => console.log("handle onConnect", params)}
        isConnectable={isConnectable}
      />
      
      <div style={{
        display: "flex",
        position: "absolute",
        right: 12,
        top: 12,
        cursor: "pointer",
        gap: 8
      }}>
        <ContentCopy
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("duplicate");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ec4899' } }}
        />
        <Delete
          onClick={() => {
            storageItems.setNodesStorage(id);
            storageItems.setAct("delete");
          }}
          sx={{ width: "16px", height: "16px", color: "#9ca3af", '&:hover': { color: '#ef4444' } }}
        />
      </div>
      
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px'
      }}>
        <AccessTime sx={{ width: "18px", height: "18px", color: "#ec4899" }} />
        <div style={{ color: "#111827", fontSize: "14px", fontWeight: 600 }}>
          Agendar
        </div>
      </div>
      
      <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5', marginBottom: '8px' }}>
        <strong>Tipo:</strong> {getScheduleLabel(data?.scheduleType)}
      </div>

      {data?.scheduleType === "delay" && (
        <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5' }}>
          <strong>Tempo:</strong> {data?.delayMinutes || 0}min
        </div>
      )}

      {data?.scheduleType === "specific_time" && (
        <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5' }}>
          <strong>Hora:</strong> {data?.specificTime || "00:00"}
        </div>
      )}

      {data?.scheduleType === "recurring" && (
        <div style={{ color: "#6b7280", fontSize: "12px", lineHeight: '1.5' }}>
          <strong>Hora:</strong> {data?.recurringTime || "00:00"}
        </div>
      )}

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#ec4899",
          width: "12px",
          height: "12px",
          top: "50%",
          right: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
